var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { gptDraftLanguages, } from 'packages/email/gpt-draft/data/gptDraftLanguages';
import Icon from 'common/UIToolKit/Icon.vue';
import LanguageSwitcher from 'ui/v1/LanguageSwitcher.vue';
import { container } from 'tsyringe';
import { LanguageService } from 'services/LanguageService';
import { EmailGptDraftRepository, } from 'packages/email/gpt-draft/EmailGptDraftRepository';
import { IntercomManager } from 'packages/intercom/IntercomManager';
import { DraftState } from 'ui/v1/email/EmailComposer.vue';
var TemplateGeneratorFlyout = /** @class */ (function (_super) {
    __extends(TemplateGeneratorFlyout, _super);
    function TemplateGeneratorFlyout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showFlyout = false;
        _this.isDrafting = false;
        _this.loading = false;
        _this.generationOptions = null;
        _this.selectedLanguage = null;
        _this.selectedTone = _this.tones[0];
        _this.repo = container.resolve(EmailGptDraftRepository);
        _this.languageService = container.resolve(LanguageService);
        _this.intercom = container.resolve(IntercomManager);
        return _this;
    }
    TemplateGeneratorFlyout.prototype.mounted = function () {
        var userLanguage = this.languageService.currentLanguage;
        var foundLanguage = Object.values(gptDraftLanguages).find(function (language) { return language.key === userLanguage; });
        this.selectedLanguage = foundLanguage !== null && foundLanguage !== void 0 ? foundLanguage : gptDraftLanguages.ENGLISH;
    };
    Object.defineProperty(TemplateGeneratorFlyout.prototype, "arrowDirection", {
        get: function () {
            return this.showFlyout ? 'up' : 'down';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateGeneratorFlyout.prototype, "flyoutMenuTitle", {
        get: function () {
            return this.isDrafting ?
                "\u2728 " + this.$t('messaging.generate_template.flyout.continue') :
                "\u2728 " + this.$t('messaging.generate_template.flyout.start');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateGeneratorFlyout.prototype, "languages", {
        get: function () {
            var _this = this;
            return Object.values(gptDraftLanguages).map(function (language) { return ({
                key: language.key,
                labelWithFlag: language.flag + " " + _this.$t(language.label),
            }); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateGeneratorFlyout.prototype, "tones", {
        get: function () {
            return [
                {
                    label: "\uD83D\uDC54 " + this.$t('messaging.generate_template.flyout.style.professional'),
                    value: 'professional',
                },
                {
                    label: "\uD83E\uDD73 " + this.$t('messaging.generate_template.flyout.style.jovial'),
                    value: 'jovial',
                },
                {
                    label: "\uD83E\uDD19 " + this.$t('messaging.generate_template.flyout.style.casual'),
                    value: 'casual',
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplateGeneratorFlyout.prototype, "flyoutMenuOptions", {
        get: function () {
            return [
                {
                    label: this.$t('messaging.generate_template.flyout.options.rejection'),
                    emailType: 'reject',
                },
                {
                    label: this.$t('messaging.generate_template.flyout.options.schedule'),
                    emailType: 'interview',
                },
                {
                    label: this.$t('messaging.generate_template.flyout.options.hire'),
                    emailType: 'hire',
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    TemplateGeneratorFlyout.prototype.toggleFlyout = function (state) {
        this.showFlyout = state;
        this.$emit('flyoutToggled', state);
    };
    TemplateGeneratorFlyout.prototype.triggerDraft = function (option) {
        var _a, _b;
        this.generationOptions = {
            lang: this.selectedLanguage.key,
            tone: this.selectedTone.value,
            emailType: (_a = option === null || option === void 0 ? void 0 : option.emailType) !== null && _a !== void 0 ? _a : (_b = this.generationOptions) === null || _b === void 0 ? void 0 : _b.emailType,
        };
        this.generate();
    };
    TemplateGeneratorFlyout.prototype.generate = function () {
        var _this = this;
        var payload = {
            state: this.isDrafting ? DraftState.UPDATE : DraftState.START,
            generationOptions: this.generationOptions,
        };
        this.$emit('draft', payload);
        if (this.showFlyout) {
            this.toggleFlyout(false);
        }
        this.isDrafting = true;
        this.loading = true;
        this.repo.generateEmail(this.generationOptions).then(function (draft) {
            draft.replaceCandidateNamePlaceholders(_this.candidateName);
            var payload = {
                state: DraftState.GENERATED,
                gptResponse: draft,
            };
            _this.$emit('draft', payload);
        }).finally(function () {
            _this.loading = false;
        });
    };
    TemplateGeneratorFlyout.prototype.selectLanguage = function (key) {
        var foundLanguage = Object.values(gptDraftLanguages).find(function (language) { return language.key === key; });
        this.selectedLanguage = foundLanguage !== null && foundLanguage !== void 0 ? foundLanguage : gptDraftLanguages.ENGLISH;
    };
    __decorate([
        Prop({ required: true, default: 'x' }),
        __metadata("design:type", String)
    ], TemplateGeneratorFlyout.prototype, "candidateName", void 0);
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", Boolean)
    ], TemplateGeneratorFlyout.prototype, "hasBody", void 0);
    TemplateGeneratorFlyout = __decorate([
        Component({
            components: { LanguageSwitcher: LanguageSwitcher, Icon: Icon },
        })
    ], TemplateGeneratorFlyout);
    return TemplateGeneratorFlyout;
}(Vue));
export default TemplateGeneratorFlyout;
